import React, { useContext, useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { store } from '../store';
import { Link } from 'react-router-dom';

import SearchProfileCard from '../components/SearchProfileCard'

const SearchWithName = (props) => {

  const globalState = useContext(store);
  const [ users, setUsers ] = useState([])
  const [ nameStarts, setNameStarts ] = useState('abcd')


  const handleFormSubmit = async (value) => {
    setNameStarts(value)
    const formData = {
      name_starts: value,
    }
    const response = await fetch( '/api/v1/search_with_name', {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': globalState.state.Authentication
      },
      method: 'post',
      body: JSON.stringify(formData)
    })
    const profiles = await response.json()

    if (response.ok) {
      setUsers(profiles)
    } else {
    }
  }


  useEffect( () => {
    handleFormSubmit('abcd');
  }, []);

  const usersData = users.map( u => {
    return (
      <SearchProfileCard
        key={u.id}
        name={u.user.first_name + ' ' + u.user.last_name.substring(0, 1)}
        image_url={u.user?.image_url}
        city={u.user.city}
        country={u.user.country_name}
        service={u.primary_service}
        service_exp={u.primary_service_exp}
        education={u.main_education}
        summary={u.summary}
        userData={u}
      />
    )
  })

  const totalCount = () => {
    return `${users.length} consultant${ users.length > 1 ? 's' : '' } found`
  }
  return (
    <div className="">
      <form onSubmit={handleFormSubmit} className="row g-2 border-bottom">
        <div className="row g-2">
          <div className="col-md g-2 text-start">
            <h2 className="card-title page-title my-3"><FontAwesomeIcon icon="address-book" /> Consultants - By Name</h2>
          </div>
        </div>

        <div className="d-flex align-items-center justify-content-between">
          <div className='name-grouping-container'>
            <a onClick={() => handleFormSubmit('a')} className={nameStarts == 'a' ? 'active' : ''}
              role="button">A</a>
            <a onClick={() => handleFormSubmit('b')} className={nameStarts == 'b' ? 'active' : ''}
              role="button">B</a>
            <a onClick={() => handleFormSubmit('c')} className={nameStarts == 'c' ? 'active' : ''}
              role="button">C</a>
            <a onClick={() => handleFormSubmit('d')} className={nameStarts == 'd' ? 'active' : ''}
              role="button">D</a>
            <a onClick={() => handleFormSubmit('e')} className={nameStarts == 'e' ? 'active' : ''}
              role="button">E</a>
            <a onClick={() => handleFormSubmit('f')} className={nameStarts == 'f' ? 'active' : ''}
              role="button">F</a>
            <a onClick={() => handleFormSubmit('g')} className={nameStarts == 'g' ? 'active' : ''}
              role="button">G</a>
            <a onClick={() => handleFormSubmit('h')} className={nameStarts == 'h' ? 'active' : ''}
              role="button">H</a>
            <a onClick={() => handleFormSubmit('i')} className={nameStarts == 'i' ? 'active' : ''}
              role="button">I</a>
            <a onClick={() => handleFormSubmit('j')} className={nameStarts == 'j' ? 'active' : ''}
              role="button">J</a>
            <a onClick={() => handleFormSubmit('k')} className={nameStarts == 'k' ? 'active' : ''}
              role="button">K</a>
            <a onClick={() => handleFormSubmit('l')} className={nameStarts == 'l' ? 'active' : ''}
              role="button">L</a>
            <a onClick={() => handleFormSubmit('m')} className={nameStarts == 'm' ? 'active' : ''}
              role="button">M</a>
            <a onClick={() => handleFormSubmit('n')} className={nameStarts == 'n' ? 'active' : ''}
              role="button">N</a>
            <a onClick={() => handleFormSubmit('o')} className={nameStarts == 'o' ? 'active' : ''}
              role="button">O</a>
            <a onClick={() => handleFormSubmit('p')} className={nameStarts == 'p' ? 'active' : ''}
              role="button">P</a>
            <a onClick={() => handleFormSubmit('q')} className={nameStarts == 'q' ? 'active' : ''}
              role="button">Q</a>
            <a onClick={() => handleFormSubmit('r')} className={nameStarts == 'r' ? 'active' : ''}
              role="button">R</a>
            <a onClick={() => handleFormSubmit('s')} className={nameStarts == 's' ? 'active' : ''}
              role="button">S</a>
            <a onClick={() => handleFormSubmit('t')} className={nameStarts == 't' ? 'active' : ''}
              role="button">T</a>
            <a onClick={() => handleFormSubmit('u')} className={nameStarts == 'u' ? 'active' : ''}
              role="button">U</a>
            <a onClick={() => handleFormSubmit('v')} className={nameStarts == 'v' ? 'active' : ''}
              role="button">V</a>
            <a onClick={() => handleFormSubmit('w')} className={nameStarts == 'w' ? 'active' : ''}
              role="button">W</a>
            <a onClick={() => handleFormSubmit('x')} className={nameStarts == 'x' ? 'active' : ''}
              role="button">X</a>
            <a onClick={() => handleFormSubmit('y')} className={nameStarts == 'y' ? 'active' : ''}
              role="button">Y</a>
            <a onClick={() => handleFormSubmit('z')} className={nameStarts == 'z' ? 'active' : ''}
              role="button">Z</a>
          </div>
          <div>
            <Link to={"/search"}>Click here to search by filter</Link>
          </div>

        </div>
        <div className="row g-2">
          <div className="text-center m-0 mb-2">
            <h5 className="fw-bolder">{totalCount()}</h5>
          </div>
        </div>
      </form>

      <div className="row d-flex align-items-center overflow-search-scorll search-with-name">
        {usersData}
      </div>

    </div>
  );
}

export default SearchWithName;
